import { useRef, type Ref } from 'react';
import { useButton, useFocusRing, mergeProps } from 'react-aria';
import type { AriaButtonProps } from 'react-aria';

import { mergeRefs } from '../../lib/mergeRefs';
import { Glyph } from '../common/Glyph';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';
import styles from './TabAddButton.module.css';

export interface TabAddButtonProps extends AriaButtonProps<'button'> {
  className?: string;
  title?: string;
  ref?: Ref<HTMLButtonElement>;
}

export function TabAddButton(props: TabAddButtonProps) {
  const ref = useRef<HTMLButtonElement>(null);
  const button = useButton(props, ref as React.RefObject<Element>);
  const focusRing = useFocusRing({});

  return (
    <button
      {...mergeProps(button.buttonProps, focusRing.focusProps)}
      ref={mergeRefs([ref, props.ref])}
      className={[styles.root, props.className].filter(Boolean).join(' ')}
      title={props.title}
      data-is-pressed={button.isPressed ? '' : undefined}
      data-is-focus-visible={focusRing.isFocusVisible ? '' : undefined}
    >
      <Glyph
        source={glyph.core.plusMedium}
        size={theme.icon.size_default}
        color={theme.color.white}
      />
    </button>
  );
}
